module.exports = __webpack_public_path__ + "img/57.00e00e3e.jpg";